// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var initialBodyImgFrame = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(160)),
            /* :: */[
              Css.height(Css.px(160)),
              /* :: */[
                Css.margin4(Css.px(5), Css.px(0), Css.px(15), Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var initialBodyImg = Css.style(/* :: */[
      Css.flexDirection(Css.column),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.justifyContent(Css.center),
          /* :: */[
            Css.width(Css.px(148)),
            /* :: */[
              Css.height(Css.px(148)),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.borderRadius(/* `percent */[
                        -119887163,
                        50.0
                      ]),
                  /* :: */[
                    Css.padding2(Css.px(0), Css.px(0)),
                    /* :: */[
                      Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(4)], /* None */0, /* None */0, Css.rgba(244, 48, 134, 0.15)),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var roundIconBox = Css.style(/* :: */[
      Css.width(/* `percent */[
            -119887163,
            100.0
          ]),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var roundIcon = Css.style(/* :: */[
      Css.margin2(Css.px(20), Css.px(0)),
      /* :: */[
        Css.width(/* `percent */[
              -119887163,
              100.0
            ]),
        /* [] */0
      ]
    ]);

var countNumber = Css.style(/* :: */[
      Css.fontSize(Css.px(40)),
      /* :: */[
        Css.margin2(Css.px(20), Css.px(8)),
        /* [] */0
      ]
    ]);

var Styles = /* module */[
  /* initialBodyImgFrame */initialBodyImgFrame,
  /* initialBodyImg */initialBodyImg,
  /* roundIconBox */roundIconBox,
  /* roundIcon */roundIcon,
  /* countNumber */countNumber
];

var component = ReasonReact.reducerComponent("Counter");

function make(countdownTime, time, fixed, _) {
  var newrecord = component.slice();
  newrecord[/* willReceiveProps */3] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* render */9] = (function () {
      var match = +(fixed !== /* true */1);
      return React.createElement("div", {
                  className: initialBodyImgFrame
                }, React.createElement("div", {
                      className: initialBodyImg
                    }, React.createElement("h1", {
                          className: countNumber
                        }, match !== 0 ? String(time) : String(countdownTime))));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[/* count */countdownTime];
    });
  newrecord[/* reducer */12] = (function (_, state) {
      var match = state[/* count */0];
      if (match !== 0) {
        return /* Update */Block.__(0, [/* record */[/* count */state[/* count */0] - 1 | 0]]);
      } else {
        return /* SideEffects */Block.__(2, [(function () {
                      return /* () */0;
                    })]);
      }
    });
  newrecord[/* subscriptions */13] = (function (self) {
      return /* :: */[
              /* Sub */[
                (function () {
                    return setInterval((function () {
                                  return Curry._1(self[/* send */4], /* Tick */0);
                                }), 1000);
                  }),
                (function (prim) {
                    clearInterval(prim);
                    return /* () */0;
                  })
              ],
              /* [] */0
            ];
    });
  return newrecord;
}

exports.Styles = Styles;
exports.component = component;
exports.make = make;
/* initialBodyImgFrame Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/counter.re
// module id = 122
// module chunks = 0